import firebase from "../../firebase";

export default function({ officeId, subscriptionId, quantity }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "billingAdmin",
        funcName: "changeSubscriptionQuantity",
        data: { officeId, subscriptionId, quantity }
    });
}
